import { render } from "./WelcomeHealthRecords.vue?vue&type=template&id=44fa79c8&scoped=true"
import script from "./WelcomeHealthRecords.vue?vue&type=script&lang=js"
export * from "./WelcomeHealthRecords.vue?vue&type=script&lang=js"

import "./WelcomeHealthRecords.vue?vue&type=style&index=0&id=44fa79c8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fa79c8"]])

export default __exports__